import moment from 'moment-timezone';

import { cleanedText } from 'common-src/presenters';
import { isEmailValid, isMBIValid, isNameValid } from 'common-src/utils/validationUtils';

import { CaregiverMedicareStatus } from './constants';

export const validatePatientCaregiver = (field, value, data = {}, isGuide = false) => {
  let errMsg = '';
  switch (field) {
    case 'firstName':
      if (!value) {
        errMsg = 'First name should not be empty';
      } else if (!isNameValid(value)) {
        errMsg = 'Invalid first name';
      } else if (value.length > 35) {
        errMsg = 'First name should be a maximum of 35 characters';
      }
      break;
    case 'lastName':
      if (!value) {
        errMsg = 'Last name should not be empty';
      } else if (!isNameValid(value)) {
        errMsg = 'Invalid last name';
      } else if (value.length > 35) {
        errMsg = 'Last name should be a maximum of 35 characters';
      }
      break;
    case 'isPrimary':
      if (typeof value !== 'boolean') {
        errMsg = 'Is primary should not be empty';
      }
      break;
    case 'email':
      if (!value) {
        errMsg = 'Email should not be empty';
      } else if (!isEmailValid(value)) {
        errMsg = 'Invalid email';
      } else if (value.length > 35) {
        errMsg = 'Email should be a maximum of 35 characters';
      }
      break;
    case 'dateOfBirth':
      if (isGuide && !value) {
        errMsg = 'Date of birth should not be empty';
      } else if (value && moment(value).format('YYYY-MM-DD') > moment().format('YYYY-MM-DD')) {
        errMsg = 'Date should not be in the future';
      }
      break;
    case 'phone':
      if (!value) {
        errMsg = 'Phone number should not be empty';
      } else if (cleanedText(value).length !== 10) {
        errMsg = 'Phone number is not valid';
      }
      break;
    case 'phoneType':
      if (!value) {
        errMsg = 'Phone type should not be empty';
      }
      break;
    case 'sex':
      if (isGuide && !value) {
        errMsg = 'Sex should not be empty';
      }
      break;
    case 'relationship':
      if (!value) {
        errMsg = 'Relationship should not be empty';
      }
      break;
    case 'livesWithPatient':
      if (typeof value !== 'boolean') {
        errMsg = 'Lives with patient should not be empty';
      }
      break;
    case 'medicareStatus':
      if (isGuide && !value) {
        errMsg = 'Medicare status should not be empty';
      }
      break;
    case 'mbi':
      if (data.medicareStatus === CaregiverMedicareStatus.Yes && !value) {
        errMsg = 'MBI number should not be empty';
      } else if (value && !isMBIValid(value)) {
        errMsg = 'Invalid medicare number';
      }
      break;
    case 'roleYears':
      if (isGuide && typeof value !== 'number' && !data.roleMonths) {
        errMsg = 'Role years should not be empty';
      } else if (typeof value === 'number' && value < 1) {
        errMsg = 'Role years should be more than 0';
      }
      return { [field]: errMsg, roleMonths: '' };
    case 'roleMonths':
      if (isGuide && typeof value !== 'number' && !data.roleYears) {
        errMsg = 'Role months should not be empty';
      } else if (typeof value === 'number' && value > 11) {
        errMsg = 'Role months should be less than 12';
      }
      return { [field]: errMsg, roleYears: '' };
    case 'preferredLanguage':
      if (!value) {
        errMsg = 'Preferred language should not be empty';
      }
      break;
    case 'techComfortLevel':
      if (!value) {
        errMsg = 'Tech comfort level should not be empty';
      }
      break;
    default:
      errMsg = '';
  }

  return { [field]: errMsg };
};
